import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { catchError, forkJoin, Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";

export const revNotesLevelDetailsResolver: ResolveFn<Observable<any>> = (route, state) => {
  const sub_slug = route.paramMap.get("sub");
  const subTopic_slug = route.paramMap.get("subTopic");
  const cur_slug = route.queryParamMap.get("cur_slug");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;


  const request = forkJoin({
    sidebar: _httpClient.get(
      `${baseUrl}api/website/subjects/${sub_slug}/revision-notes/sidebar?curriclum_slug=${cur_slug}`,
    ).pipe(
      catchError((err) => {
        _alertMessageService.addMsg(err?.error?.msg || "Error loading topics data");
        return of(undefined);
      }),
    ),
    // subTopics: _httpClient.get(
    //   `${baseUrl}api/website/sub-topics/${subTopic_slug}/revision-notes?curriclum_slug=${cur_slug}&page=${page}`,
    // ),
  });

  return request ;

  
};
